module.exports = __webpack_public_path__ + "static/TradeGothicLTStd-BdCn20-952d37d2e85dc50a84d2dafe54b22e42.woff";